import { ReactElement } from "react";
import { twMerge } from "tailwind-merge";
import { AlertCircle } from "lucide-react";
import { Loader } from "@shared/ui/Loader";
import { Type } from "@shared/ui/Type";

interface Props {
  children: ReactElement | ReactElement[];
  isLoading: boolean;
  isSubmitting: boolean;
  errors: any;
  onSubmit?: (data: any) => void;
  className?: string;
  innerClassName?: string;
  errorContainerClassName?: string;
}

export function Form({
  children,
  isLoading,
  isSubmitting,
  onSubmit,
  errors,
  className,
  innerClassName,
  errorContainerClassName,
}: Props) {
  const isLoadingOrSubmitting = isLoading || isSubmitting;

  return (
    <form
      onSubmit={onSubmit}
      className={twMerge("relative flex flex-col", className)}
    >
      {isLoadingOrSubmitting && <Loader isAbsolute />}
      <div
        className={twMerge(
          "flex-1 flex flex-col gap-4 transition-opacity duration-200",
          innerClassName,
          isLoadingOrSubmitting && "opacity-20"
        )}
      >
        {children}
      </div>

      {errors.root && (
        <div
          className={twMerge(
            "w-full mx-auto flex flex-col max-w-xl mt-8",
            errorContainerClassName
          )}
        >
          <div className="flex flex-col gap-2 border-2 border-error rounded-md p-4">
            <div className="flex flow-row items-center gap-2">
              <AlertCircle className="h-5 w-5 text-error" />
              <Type variant="h6" className="text-error">
                Something went wrong
              </Type>
            </div>
            <Type variant="caption" className="text-error">
              {errors.root.message}
            </Type>
          </div>
        </div>
      )}
    </form>
  );
}

export default Form;
